














import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import KoutsuhiPatternCardList from '@/components/pattern/organisms/KoutsuhiPatternCardList.vue'

@Component({
  components: { TcwLayoutBasicTemplate, KoutsuhiPatternCardList }
})
export default class KoutsuhiPatternListPage extends Mixins(BasePage) {}
